export const config = {
  signalR: {
    // hubUrl: process.env.REACT_APP_SIGNALR_HUB_URL || '/chatHub'
    hubUrl: 'https://test.transpay.devproxy.ru/messageHub',
  },
};
